
// * ========================================================================
// * totalPerDay chart
// * ========================================================================


import Tablesorter from './../table-sorter';
import CovidChart from './covid-chart.js';
import moment from 'moment';
import storage from './../storage';

const regionsPerDay = (function(){
    const maxPadding = 1.15; // + %
    let thisChart = null;
    let dataType = null;
    let typeSelectors = null;
    const typeSelectorClass = 'input[name=region-line-chart-data]';
    let chartData = null;

    /**
     *
     * Show new cases per day table
     *
     * @param {Array} data - covid data
     * @param {Array} options - options
     */
    function showTable(data, options) {
        const firstDate = options.firstDate.format('D.M') + '. jälkeen';
        let headings = '<th>SHP</th>';
        headings += '<th class="align-right sorting" data-sort="number">Ilmaan&shy;tuvuus</th>';
        headings += '<th class="align-right" data-sort="number">Yhteensä</th>';
        headings += '<th class="align-right" data-sort="number">'+firstDate+'</th>';
        headings += '<th class="align-right" data-sort="number">Uusia</th>';

        const markup = ['<tr>'+headings+'</tr>'];

        const firstDayString = options.firstDate.format('YYYY-MM-DD');
        const areaData = data.firstDayCounts && typeof data.firstDayCounts[firstDayString] !== 'undefined' ? data.firstDayCounts[firstDayString].areas : null;

        for (let area of data.areas) {
            const firstDayCount = areaData && typeof areaData[area.id] !== 'undefined' && areaData[area.id].firstDayCount ? areaData[area.id].firstDayCount : 0;

            const newCount = area.totalCount === 0 ? 0 : area.totalCount - firstDayCount;
            const newCountStr = area.totalCount === 0 ? '' : newCount;

            const change = typeof area.newCount !== 'undefined' ? area.newCount : 0;
            const changeStr = typeof area.newCount === 'undefined' ? '' : change ? change > 0 ? '<span class="color-red">+'+change+'</span>' : change : 0;

            const rateString = 'rate_' + window.config.rateDays;
            let rate = area[rateString] ? area[rateString] : 0;
            let rateStr = rate === 0 ? '' : area[rateString];
            // 10 >= kiihtymisvaihe 18 >= leviämisvaihe
            if (area[rateString] >= 18) {
                rateStr = '<span class="color-red">'+area[rateString]+'</span>';
            } else if (area[rateString] >= 10) {
                rateStr = '<span class="color-orange">'+area[rateString]+'</span>';
            }

            let row = '<tr>';
            row += '<td data-dataset-id="'+ area.id +'" data-value="'+area.name+'">'+area.name+'</td>'; // data-clear-dataset="all"
            row += '<td data-value="'+rate+'" class="align-right">'+rateStr+'</td>';
            row += '<td data-value="'+area.totalCount+'" class="align-right">'+area.totalCount+'</td>';
            row += '<td data-value="'+newCount+'" class="align-right">'+newCountStr+'</td>';
            row += '<td data-value="'+change+'" class="align-right">'+changeStr+'</td>';
            row += '</tr>';

            markup.push(row);
        }

        const tableContainer = document.getElementById('region-line-table');
        tableContainer.innerHTML = '<table class="table slim">'+markup.join('')+'</table>';
        const table = tableContainer.querySelector('table');

        const tablesorter = new Tablesorter(table);

        // Set new order
        const sorter = table.querySelector('th.sorting');
        tablesorter.sortBy(sorter);
    }

    function createChartData(data, options, selected) {
        let dataInitialMax = null;

        let datasets = [];
        const datasetAll = {
            label: 'Tartunnat yhteensä',
            id: 'all',
            name: 'Tartunnat yhteensä',
            backgroundColor: '#0293d6',
            borderColor: '#0293d6',
            borderWidth: 3,
            count: 0,
            fill: false,
            data: [],
            type: 'LineWithLine',
            pointRadius: 0,
            selected: typeof selected !== 'undefined' && selected.indexOf('all') !== -1
        };

        const rateString = 'rate_' + window.config.rateDays;
        const firstDayString = options.firstDate.format('YYYY-MM-DD');
        const firstDayData = data.firstDayCounts && typeof data.firstDayCounts[firstDayString] !== 'undefined' ? data.firstDayCounts[firstDayString] : null;

        for (let idx = 0; idx < data.days.length; idx++) {
            const day = data.days[idx];
            const date = moment(day.date);

            if (date >= options.firstDate) {
                // Set value for dataset "All"
                let count;
                if (dataType === 'date') {
                    const firstDayCount = firstDayData ? firstDayData.firstDayCount : 0;
                    count = day.totalCount - firstDayCount;
                } else if (dataType === 'rate') {
                    count = day[rateString] ? day[rateString] : 0;
                } else {
                    count = day.totalCount;
                }

                datasetAll.data.push({
                    x: date,
                    y: count
                });

                datasetAll.count = count;

                dataInitialMax = count * maxPadding;

                // Set values per area
                for (const [i, area] of data.areaDays[idx].areas.entries()) {
                    const areaData = data.areas[area.index];
                    if (typeof datasets[i] === 'undefined') {
                        datasets.push({
                            label: areaData.name,
                            name: areaData.name,
                            id: areaData.id,
                            borderColor: options.chartColors[i],
                            borderWidth: 3,
                            count: 0,
                            fill: false,
                            data: [],
                            pointRadius: 0,
                            type: 'LineWithLine',
                            selected: typeof selected !== 'undefined' && selected.indexOf(areaData.id) !== -1
                        });
                    }

                    let areaCount;
                    if (dataType === 'date') {
                        const firstDayCount = firstDayData ? firstDayData.areas[areaData.id].firstDayCount : 0;
                        areaCount = area.totalCount - firstDayCount;
                    } else if (dataType === 'rate') {
                        areaCount = area[rateString] ? area[rateString] : 0;
                    } else {
                        areaCount = area.totalCount;
                    }

                    datasets[i].data.push({
                        x: date,
                        y: areaCount
                    });

                    datasets[i].count = areaCount;
                }
            }
        }

        datasets = datasets.map((item, i) => {
            item.borderColor = options.chartColors[i];
            return item;
        });
        datasets.unshift(datasetAll);

        return datasets;//, dataInitialMax };
    }

    function getDataType() {
        dataType = document.querySelector(typeSelectorClass+':checked').value;
        return dataType;
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        chartData = data;
        typeSelectors = document.querySelectorAll(typeSelectorClass);

        // Get the data type we want to show
        getDataType();

        // Initially selected
        let selectedRegions = storage.getData('region-line-chart_multiselect');
        if (!selectedRegions || !Array.isArray(selectedRegions)) {
            selectedRegions = ['all']; // All for default
        }

        // Show table
        showTable(chartData, window.config);

        const datasets = createChartData(chartData, window.config, selectedRegions);

        thisChart = new CovidChart('region-line-chart', {
            datasets,
            chartOptions: {
                options: {
                    plugins: {
                        legend: {
                            display: true
                        },
                        tooltip: {
                            intersect: false,
                            position: 'nearest',
                            bodySpacing: 5,
                        }
                    },
                    scales: {
                        x: {
                            type: 'time',
                            display: true,
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'D.M',
                                }
                            },
                            title: {
                                display: false,
                                text: 'Päivämäärä'
                            },
                            ticks: {
                                major: {
                                    fontStyle: 'bold',
                                    fontColor: '#FF0000'
                                }
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: false,
                                text: 'Tartuntojen määrä'
                            }
                        }
                    }
                }
            },
            delayAnnotation: true,
            config: window.config,
            tooltips: {
                elementId: 'region-line-chart-tooltip'
            },
            multiselect: {
                requireCount: true,
                valueType: 'string',
                idField: 'id',
                colorField: 'borderColor',
                inputName: 'region-line-multiselect',
                selectElemId: 'region-line-multiselect',
                colorElemId: 'region-line-multiselect-colors',
                countElemId: 'region-line-multiselect-count',
                selectAllElemId: 'region-line-multiselect-select-all',
                clearAllElemId: 'region-line-multiselect-clear-all'
            },
            responsive: ['aspectRatio', 'legend']
        });

        // Create listener for type change
        typeSelectors.forEach((typeSelector) => {
            typeSelector.addEventListener('change', () => {
                let newType = document.querySelector(typeSelectorClass+':checked').value;
                if (dataType !== newType) {
                    reload(null, true);
                }
            });
        });
    }

    function reload(data = null, changeType = false) {
        if (data) {
            chartData = data;
        }

        // Get the data type we want to show
        getDataType();

        if (!changeType) {
            // Re render table only when date has changed
            showTable(chartData, window.config);
        }

        // Update data
        const datasets = createChartData(chartData, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default regionsPerDay;
